import baseAPI from "@/api/base";
import { AssignRepToCompanies, EditCompany, GetCompany, RegisterCompany } from "@/dtos/Company.dto";
import {
  ASSIGN_REP_TO_COMPANIES_URL,
  DELETE_COMPANY_URL,
  EDIT_COMPANY_URL,
  GET_COMPANY_URL,
  MERGE_COMPANIES_URL,
  REGISTER_COMPANY_URL,
  SAVE_COMPANY_LOGO_URL,
  TOGGLE_COMPANY_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Company {
  static getCompanies = async (getCompany: GetCompany): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_COMPANY_URL, {
      params: getCompany,
    });
    return response;
  };

  static getIndustries = async (params: { organizationId: string }): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(`${GET_COMPANY_URL}/industries`, {
      params,
    });
    return response;
  };

  static registerCompany = async (registerCompany: RegisterCompany): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_COMPANY_URL, {
      ...registerCompany,
    });
    return response;
  };

  static editCompany = async (editCompany: EditCompany): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_COMPANY_URL, {
      ...editCompany,
    });
    return response;
  };

  static toggleCompanyIsActive = async (editCompany: EditCompany): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_COMPANY_IS_ACTIVE_URL, {
      ...editCompany,
    });
    return response;
  };

  static deleteCompany = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_COMPANY_URL}/${id}`);
    return response;
  };

  static exportCompanies = async (params: {
    companyIds?: string[];
    customFieldIds?: string[];
  }): Promise<AxiosResponse> => {
    return baseAPI.post("/report/companies/export", params, { responseType: "blob" });
  };

  static assignRepToCompanies = async (data: AssignRepToCompanies): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(ASSIGN_REP_TO_COMPANIES_URL, {
      ...data,
    });
    return response;
  };

  static mergeCompanies = async (data: {
    primaryId: string;
    secondaryId: string;
  }): Promise<AxiosResponse> => {
    return baseAPI.post(MERGE_COMPANIES_URL, data);
  };

  static saveCompanyLogo = async (companyId: string, logoUrl: string): Promise<AxiosResponse> => {
    return baseAPI.post(`${SAVE_COMPANY_LOGO_URL}/${companyId}/logo`, { logoUrl });
  };
}

export default Company;
